// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"24":"companies","417":"extensions","644":"account"}[chunkId] || chunkId) + "." + {"24":"5cf6e95c","393":"e894a8bc","417":"dca85f91","482":"5f3fe577","644":"d49b5d1b"}[chunkId] + ".js";
};